export enum IEmployeeActionTypes {
  FETCH_EMPLOYEE_LIST_REQUEST = "FETCH_EMPLOYEE_LIST_REQUEST",
  FETCH_EMPLOYEE_LIST_SUCCESS = "FETCH_EMPLOYEE_LIST_SUCCESS",
  FETCH_EMPLOYEE_LIST_FAILURE = "FETCH_EMPLOYEE_LIST_FAILURE",
}

export enum IEmployeeTypes {
  EMPLOYEE_LIST_REQUEST = "EMPLOYEE_LIST_REQUEST",
  EMPLOYEE_LIST_SUCCESS = "EMPLOYEE_LIST_SUCCESS",
  EMPLOYEE_LIST_FAILURE = "EMPLOYEE_LIST_FAILURE",
}

export type IEmployeeState = {
  employee_id?: string;
  entity_id?: string;
  name?: string;
  employee_code?: string;
  phone_number?: string;
  team_id?: number;
  team?: string;
  designation?: string;
  sub_team_id?: number;
  checked?: boolean;
};

export type IEmployeeListState = {
  data: IEmployeeState[];
};

export type IEmployeeManagementState = {
  data: IEmployeeManagementData;
};

export type IEmployeeActionCreator = {
  type: string;
  payload: IEmployeeState;
};

export type IEmployeeCreator = {
  type: string;
  payload: IEmployeeManagementData;
};

export type IEmployeeManagementData = {
  current_page: number;
  data: IEmployeeData[];
  designations_list: IUserList[];
  employees_list: IUserList[];
  error: string;
  limit: number;
  message: string;
  status: string;
  teams_list: IUserList[];
  total_items: number;
  total_pages: number;
};

export type IEmployeeData = {
  employee_id: string;
  entity_id: string;
  name: string;
  employee_code: string;
  phone_number: string;
  team_id: number;
  team: string;
  designation: string;
  sub_team_id: number;
  sub_team: string;
};

export type IUserList = {
  id: number;
  name: string;
};

export interface IEmployeeMapping {
  id: number;
  workflow_id: number;
  employee_id: string;
  employee_name?: string;
  phone_number?: string;
  entity_id: string;
  created_at: string;
  updated_at: string;
}
